/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { webApi } from '../../../lib/WebApi.js'
import { multisportify } from "trux";

export const addPlayer = (teamName, playerAttr, relations, gameId = null, callback = null) => {
    playerAttr['is_player'] = 1
    return (dispatch, getState) => {
        checkMatchingPlayer(playerAttr.first_name, playerAttr.last_name, playerAttr.email)
            .then(matchingPlayer => {
                if (matchingPlayer) {
                    var playerAttrFN = `${playerAttr.first_name} ${playerAttr.last_name}`
                    var matchingPlayerFN = `${matchingPlayer.first_name} ${matchingPlayer.last_name}`
                    if (matchingPlayerFN !== playerAttrFN) {
                        dispatch({
                            type: 'COMMON_SET',
                            key: 'misc',
                            value: {
                                value: {
                                    addPlayerInProgress: false,
                                    addPlayerError: 'email_existing_user',
                                    addPlayerMatchingUser: matchingPlayer,
                                    addPlayerMatchingRelations: []
                                }
                            }
                        })
                        throw('email_existing_user') // eslint-disable-line no-throw-literal
                    }
                }
                return null
            })
            .then( () => {
                return checkMatchingRelations(relations)
            })
            .then( matchingRelations => {
                if (matchingRelations && matchingRelations.length > 0) {
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'misc',
                        value: {
                            value: {
                                addPlayerInProgress: false,
                                addPlayerError: 'email_existing_user',
                                addPlayerMatchingUser: null,
                                addPlayerMatchingRelations: matchingRelations
                            }
                        }
                    })
                    throw('email_existing_user') // eslint-disable-line no-throw-literal
                } else {
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'misc',
                        value: {
                            value: {
                                addPlayerInProgress: true,
                                addPlayerError: null,
                                addPlayerMatchingUser: null,
                                addPlayerMatchingRelations: null
                            }
                        }
                    })
                }
            })
            .then( () => {
                return createPlayer(gameId, teamName, playerAttr, {})
            })
            .then(data => {
                // get roster list
                return getRosterList(gameId, data)
            })
            .then(data => {
                // match user from roster list
                for (var i in data.roster) {
                    var p = data.roster[i]
                    if (p.team_player_id === data.team_player_id) {
                        data['player'] = p
                        break
                    }
                }
                return data
            })
            .then(data => {
                return addAllRelations(data.player.user_id, relations, data)
            })
            .then(data => {
                return getRosterList(gameId, data)
            })
            .then(data => {
                dispatch({
                    type: 'COMMON_SET',
                    key: 'roster',
                    value: { value: null, loading: false, complete: false, error: null }
                })
                callback(data, null)
            })
            .catch(err => {
                console.error('actions.add_player.addPlayer ERROR:', err)
                dispatch({
                    type: 'COMMON_SET',
                    key: 'misc',
                    value: {
                        value: {
                            addPlayerInProgress: false,
                            addPlayerError: err
                        }
                    }
                })
                callback(null, err)
            })
    }
}

export const updatePlayer = (playerId, userId, playerAttr, addRelations, removeRelations, gameId = null, callback = null) => {
    return (dispatch, getState) => {
        checkMatchingPlayer(playerAttr.first_name, playerAttr.last_name, playerAttr.email)
            .then(matchingPlayer => {
                if (matchingPlayer) {
                    var playerAttrFN = `${playerAttr.first_name} ${playerAttr.last_name}`
                    var matchingPlayerFN = `${matchingPlayer.first_name} ${matchingPlayer.last_name}`
                    if (matchingPlayerFN !== playerAttrFN) {
                        dispatch({
                            type: 'COMMON_SET',
                            key: 'misc',
                            value: {
                                value: {
                                    editPlayerInProgress: false,
                                    editPlayerError: 'email_existing_user',
                                    editPlayerMatchingUser: matchingPlayer,
                                    editPlayerMatchingRelations: []
                                }
                            }
                        })
                        throw('email_existing_user') // eslint-disable-line no-throw-literal
                    }
                }
                return null
            })
            .then( () => {
                return checkMatchingRelations(addRelations)
            })
            .then( matchingRelations => {
                if (matchingRelations && matchingRelations.length > 0) {
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'misc',
                        value: {
                            value: {
                                editPlayerInProgress: false,
                                editPlayerError: 'email_existing_user',
                                editPlayerMatchingUser: null,
                                editPlayerMatchingRelations: matchingRelations
                            }
                        }
                    })
                    throw('email_existing_user') // eslint-disable-line no-throw-literal
                } else {
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'misc',
                        value: {
                            value: {
                                editPlayerInProgress: true,
                                editPlayerError: null,
                                editPlayerMatchingUser: null,
                                editPlayerMatchingRelations: null
                            }
                        }
                    })
                }
            })
            .then(() => {
                return doUpdatePlayer(gameId, playerId, playerAttr, {})
            })
            .then(data => {
                return removeAllRelations(userId, removeRelations, data)
            })
            .then(data => {
                return addAllRelations(userId, addRelations, data)
            })
            .then(data => {
                return getRosterList(gameId, data)
            })
            .then(data => {
                dispatch({
                    type: 'COMMON_SET',
                    key: 'roster',
                    value: { value: null, loading: false, complete: false, error: null }
                })
                callback(data, null)
            })
            .catch(err => {
                console.error('actions.update_player.addPlayer ERROR:', err)
                dispatch({
                    type: 'COMMON_SET',
                    key: 'roster',
                    value: { value: null, loading: false, complete: false, error: null }
                })
                dispatch({
                    type: 'COMMON_SET',
                    key: 'misc',
                    value: {
                        value: {
                            editPlayerInProgress: false,
                            editPlayerError: err
                        }
                    }
                })
                callback(null, err)
            })
    }
}

export function swapPlayer(playerId, playerAttr, gameId = null, callback = null) {
    return (dispatch, getState) => {

        // find orig player and related dummy player to fix up unset trace sensor
        var origPlayer = null
        var toDummyPlayer = null
        var fromDummyPlayer = null
        var swapPlayer = null
        let state = getState()
        var allPlayers = state.roster.value ? state.roster.value : []
        for (var i in allPlayers) {
            var p = allPlayers[i]
            if (p.team_player_id === playerId) {
                origPlayer = p
                break
            }
        }

        if (origPlayer != null) {
            let i = 0
            let p = null

            for (i in allPlayers) {
                p = allPlayers[i]
                if (p.default_trace_number === playerAttr['default_trace_number'] && p.team_player_id !== origPlayer.team_player_id && p.default_trace_number > 0 && p.user.is_dummy === 0) {
                    swapPlayer = p
                    break
                }
            }

            for (i in allPlayers) {
                p = allPlayers[i]
                if (p.user.first_name === `Tracer ${origPlayer['default_trace_number']}` && p.user.is_dummy === 1) {
                    fromDummyPlayer = p
                    break
                }
            }

            if(!fromDummyPlayer) {
                for (let i in allPlayers) {
                    p = allPlayers[i]
                    if (p.user.first_name === 'Tracer' && p.user.is_dummy === 1 &&
                        (p.default_trace_number === '0' || p.default_trace_number === '-1')) {
                        fromDummyPlayer = p
                        break
                    }
                }
            }

            
            for (let p of allPlayers) {
                if (p.default_trace_number <= 0 && p.user.is_dummy === 1) {
                    toDummyPlayer = p
                    break
                }
            }
        }

        console.info('origPlayer', origPlayer)
        console.info('swapPlayer', swapPlayer)
        console.info('toDummyPlayer', toDummyPlayer)
        console.info('fromDummyPlayer', fromDummyPlayer)

        if (gameId === null) {
            swapSeason(playerAttr.default_trace_number, origPlayer, swapPlayer, fromDummyPlayer, toDummyPlayer, dispatch)
                .then(success => {
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'roster',
                        value: { value: null, loading: false, complete: false, error: null }
                    })
                    if (callback) { callback(success) }
                })
                .catch(err => {
                    dispatch(loadRoster(gameId, null))
                    console.error('swapPlayer season error', err)
                    if (callback) { callback(false) }
                })
        } else {
            swapGame(gameId, playerAttr.default_trace_number, origPlayer, swapPlayer, fromDummyPlayer, toDummyPlayer, dispatch)
                .then(success => {
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'roster',
                        value: { value: null, loading: false, complete: false, error: null }
                    })
                    if (callback) { callback(success) }
                })
                .catch(err => {
                    dispatch(loadRoster(gameId, null))
                    console.error('swapPlayer game error', err)
                    if (callback) { callback(false) }
                })
        }
    }
}

export function loadRoster(gameId = null, cb = null) {
    return (dispatch, getState) => {
        getRosterList(gameId, {}).then(data => {
            dispatch({ type: 'SET_ROSTER', roster: data.roster})
            if (data.actions != null) {
                for (var i in data.actions) {
                    dispatch(data.actions[i])
                }
            }
            dispatch({ type: 'SET_ROSTER_LOADED', loaded: true})
            if (cb) { cb(true) }
        })
    }
}



//// Promisable Control Functions

function checkMatchingPlayer(firstName, lastName, email) {
    return new Promise((resolve, reject) => {
        if (email == null || email.length === 0) {
            resolve(null)
            return
        }

        webApi._post('/webapp/users/search/by-email', { email })
            .then(jsonUser => {
                if (jsonUser.first_name !== firstName || jsonUser.last_name !== lastName) {
                    resolve(jsonUser)
                } else {
                    resolve(null)
                }
            })
            .catch(err => {
                resolve(null)
            })
    })
}

function checkMatchingRelations(relations) {
    return new Promise((resolve, reject) => {
        if (relations == null || relations.length === 0) {
            resolve(null)
            return null
        }

        var requests = []
        for (var i in relations) {
            var rel = relations[i]
            requests.push({
                uri: '/webapp/users/search/by-email',
                method: 'POST',
                params: { email: rel.email }
            })
        }

        var jsonRequests = JSON.stringify(requests)
        webApi._post('/webapp/batch', { requests: jsonRequests })
            .then(responses => {
                var matches = []
                for (var r in responses) {
                    var resp = responses[r]
                    var rel = relations[r]
                    if (resp.success) {
                        var re = resp.data
                        var rFN = `${re.first_name} ${re.last_name}`
                        var relFN = `${rel.first_name} ${rel.last_name}`
                        if (rFN !== relFN) {
                            var user = Object.assign({}, resp.data, {
                                email: rel.email
                            })
                            matches.push(user)
                        }
                    }
                }
                if (matches.length > 0) {
                    resolve(matches)
                } else {
                    resolve(null)
                }
            })
            .catch(err => {
                console.error('roster.actions.checkMatchingRelations', err)
                throw(err)
            })
    })
}

function createPlayer(gameId, teamName, playerAttr, data) {
    return new Promise((resolve, reject) => {
        if (gameId === null) {
            webApi.addSeasonRosterPlayer(teamName, playerAttr)
                .then(team_player_id => {
                    data['team_player_id'] = team_player_id
                    resolve(data)
                })
                .catch(err => {
                    reject({level: 'create_player', error: err})
                })
        } else {
            webApi._post(`/webapp/games/${gameId}/player/create`, playerAttr)
                .then(json => {
                    data['team_player_id'] = json.team_player_id
                    data['game_player_id'] = json.game_player_id
                    resolve(data)
                })
                .catch(err => {
                    reject({ level: 'create_player', error: err })
                })
        }
    })
}

function doUpdatePlayer(gameId, playerId, playerAttr, data) {
    return new Promise((resolve, reject) => {
        if (gameId === null) {
            webApi.updateSeasonRosterPlayer(playerId, playerAttr)
                .then(success => {
                    resolve(data)
                })
                .catch(err => {
                    reject({level: 'update_player', error: err})
                })
        }
    })
}

function getRosterList(gameId, data) {
    return new Promise((resolve, reject) => {
        var rData = {}
        getSeasonRoster(rData)
            .then(rData => {
                rData = multisportify(rData)
                if (gameId == null) {
                    return rData
                } else {
                    return getGameRoster(gameId, rData)
                }
            })
            .then (rData => {
                // merge season and game roster if needed
                var roster = []
                for (var si in rData.seasonRoster) {
                    var player = rData.seasonRoster[si]
                    if (rData.gameRoster !== undefined) {
                        player.default_trace_number = -1
                        for (var gi in rData.gameRoster) {
                            var gp = rData.gameRoster[gi]
                            if (parseInt(gp.user_id, 10) === parseInt(player.user_id, 10)) {
                                player.default_trace_number = gp.trace_number
                                player['game_player_id'] = gp.game_player_id
                                break
                            }
                        }
                    }
                    roster.push(player)
                }

                for (let plyr of roster) {
                    plyr.default_trace_number = parseInt(plyr.default_trace_number, 10)
                }
                rData['roster'] = roster
                return rData
            })
            .then(rData => {
                return addRelationsToRoster(rData.roster, rData)
            })
            .then(rData => {
                data['roster'] = rData.roster
                data['actions'] = rData.actions
                resolve(data)
            })
            .catch(err => {
                console.error('roster.actions.getRosterList ERROR', err)
                resolve(data)
            })
    })
}

function swapSeason(toTraceNumber, origPlayer, swapPlayer, fromDummyPlayer, toDummyPlayer, dispatch) {
    return new Promise((resolve, reject) => {
        var swapNumber = origPlayer.default_trace_number
        var fromDummyNumber = origPlayer.default_trace_number
        var toDummyNumber = -1

        if (swapPlayer != null) {
            // moving from player to player
            fromDummyNumber = -1
            toDummyNumber = -1
        }

        // update origPlayer
        webApi.updateSeasonRosterPlayer(origPlayer.team_player_id, { default_trace_number: toTraceNumber })
            .then(success => {
                // update dummy player if needed
                if (origPlayer != null && fromDummyPlayer != null && swapPlayer == null) {
                    return webApi.updateSeasonRosterPlayer(fromDummyPlayer.team_player_id, { default_trace_number: fromDummyNumber })
                } else {
                    return true
                }
            })
            .then(success => {
                // Update roster list
                if (origPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: origPlayer.user_id, trace_number: toTraceNumber })
                }
                if (swapPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: swapPlayer.user_id, trace_number: swapNumber })
                }
                if (fromDummyPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: fromDummyPlayer.user_id, trace_number: fromDummyNumber })
                }
                if (toDummyPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: toDummyPlayer.user_id, trace_number: toDummyNumber })
                }
                resolve(true)
            })
            .catch(err => {
                console.error('roster.actions.swapSeason error', err)
                resolve(false)
            })
    })
}

function swapGame(gameId, toTraceNumber, origPlayer, swapPlayer, fromDummyPlayer, toDummyPlayer, dispatch) {
    return new Promise((resolve, reject) => {
        var swapNumber = origPlayer.default_trace_number
        var fromDummyNumber = origPlayer.default_trace_number
        var toDummyNumber = -1

        if (swapPlayer != null) {
            // moving from player to player
            fromDummyNumber = -1
            toDummyNumber = -1
        }

        updateGamePlayer(gameId, origPlayer, toTraceNumber, toDummyPlayer)
            .then(success => {
                // Update roster list
                if (origPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: origPlayer.user_id, trace_number: toTraceNumber })
                }
                if (swapPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: swapPlayer.user_id, trace_number: swapNumber })
                }
                if (fromDummyPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: fromDummyPlayer.user_id, trace_number: fromDummyNumber })
                }
                if (toDummyPlayer != null) {
                    dispatch({ type: 'TRACE_NUMBER', user_id: toDummyPlayer.user_id, trace_number: toDummyNumber })
                }
                resolve(true)
            })
            .catch(err => {
                resolve(false)
            })
    })
}

function updateGamePlayer(gameId, player, traceNumber, dummyPlayer) {
    let params = {}

    if (player.game_player_id != null && player.game_player_id > 0) {
        if(traceNumber > 0) {
            // player to player
            params = {trace_number: traceNumber}
            return webApi._post(`/webapp/game-players/${player.game_player_id}`, params)
        } else {
            // player to open
            // here we do some weird logic. We do not delete our current player,
            // we assign a new dummy one to the same trace number.
            // This will automatically unassign our player from this trace number :(
            params = {
                team_player_id: dummyPlayer.team_player_id,
                trace_number: player.default_trace_number
            }
            return webApi._post(`/webapp/games/${gameId}/player/create`, params)
        }
    } else {
        // bench to player
        params = {
            team_player_id: player.team_player_id,
            trace_number: traceNumber
        }
        return webApi._post(`/webapp/games/${gameId}/player/create`, params)
    }
}



//// Get Rosters

function getSeasonRoster(data) {
    return new Promise((resolve, reject) => {
        webApi.getSeasonRoster()
            .then(roster => {
                roster = multisportify(roster)
                for (var i in roster) {
                    roster[i]['contacts'] = []
                }
                data['seasonRoster'] = roster
                resolve(data)
            })
            .catch(err => {
                resolve(data)
            })
    })
    
}

function getGameRoster(gameId, data) {
    return new Promise((resolve, reject) => {
        webApi._get(`/webapp/games/${gameId}/players`, {})
            .then(roster => {
                data['gameRoster'] = roster
                resolve(data)
            })
            .catch(err => {
                resolve(data)
            })
    })
}

function addRelationsToRoster(roster, data) {
    return new Promise((resolve, reject) => {
        getAllRelations(roster)
            .then(actions => {
                data['actions'] = actions
                resolve(data)
            })
            .catch(err => {
                console.error('roster.actions.getAllRelationse error', err)
                resolve(data)
            })
    })
}



//// Loading Relations

function getAllRelations(players) {
    return new Promise((resolve, reject) => {
        var filteredPlayers = players.filter(p => {
            return p.user.is_dummy === 0
        })

        var requests = []
        for (var i in filteredPlayers) {
            var player = filteredPlayers[i]
            requests.push({
                uri: `/webapp/users/${player.user_id}/relations`,
                method: 'GET'
            })
        }

        var jsonRequests = JSON.stringify(requests)
        webApi._post('/webapp/batch', { requests: jsonRequests })
            .then(responses => {
                let actions = []
                for (var r in responses) {
                    let player = filteredPlayers[r]
                    let data = responses[r].data
                    let contacts = []
                    for (var i in data) {
                        let c = {
                            _editable: false,
                            first_name: data[i].related_user.first_name,
                            last_name: data[i].related_user.last_name,
                            email: data[i].related_user.email,
                            user_relationship_id: data[i].user_relationship_id
                        }
                        contacts.push(c)
                    }
                    actions.push({ type: 'SET_PLAYER_RELATIONS', userId: player.user_id, contacts: contacts })
                }
                resolve(actions)

            })
            .catch(err => {
                console.error('rosters.actions.getAllRelations', err)
            })
    })
}

export function loadPlayerRelations(userId) {
    return (dispatch, getState) => {
        webApi._get(`/webapp/users/${userId}/relations`, {})
            .then((data) => {
                if (data) {
                    var contacts = []
                    for (var i in data) {
                        var c = {
                            _editable: false,
                            first_name: data[i].related_user.first_name,
                            last_name: data[i].related_user.last_name,
                            email: data[i].related_user.email,
                            user_relationship_id: data[i].user_relationship_id
                        }
                        contacts.push(c)
                    }
                    dispatch({ type: 'SET_PLAYER_RELATIONS', userId: userId, contacts: contacts })
                }
            })
            .catch((err) => {
                console.error('actions.loadPlayerRelations ERROR', err)
            })
    }
}


//// Adding Relations

function addAllRelations(userId, relations, data) {
    return new Promise((resolve, reject) => {
        addAllPlayerRelations(userId, relations, (success) => {
            resolve(data)
        })
    })
}

function addAllPlayerRelations(userId, relations, cb) {
    var relation = relations.pop()
    if (relation != null) {
        addPlayerRelation(userId, relation)
            .then(() => {
                addAllPlayerRelations(userId, relations, cb)
            })
    } else {
        cb(true)
    }
}

function addPlayerRelation(userId, relation) {
    return new Promise((resolve, reject) => {
        delete relation['_editable']
        webApi._post(`/webapp/users/${userId}/relations/create`, relation)
            .then((data) => {
                resolve()
            })
            .catch((err) => {
                resolve()
            })
    })
}


//// Removing Relations

function removeAllRelations(userId, relations, data) {
    return new Promise((resolve, reject) => {
        removeAllPlayerRelations(userId, relations, (success) => {
            resolve(data)
        })
    })
}

function removeAllPlayerRelations(userId, relations, cb) {
    var relation = relations.pop()
    if (relation != null) {
        removePlayerRelation(userId, relation)
            .then(() => {
                removeAllPlayerRelations(userId, relations, cb)
            })
    } else {
        cb(true)
    }
}

function removePlayerRelation(userId, relation) {
    return new Promise((resolve, reject) => {
        webApi._post(`/webapp/user-relations/${relation.user_relationship_id}/delete`, {})
            .then(data => {
                resolve()
            })
            .catch(err => {
                resolve()
            })
    })
}



